"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MAX_ARROWS = exports.DEFAULT_ARROWS = exports.ArrowStyles = void 0;
// Describes the arrow style of polylines
var ArrowStyles = {
  NONE: 0,
  FORWARD: 1,
  BACKWARD: 2,
  BOTH: 3
};
exports.ArrowStyles = ArrowStyles;
var DEFAULT_ARROWS = 1;
exports.DEFAULT_ARROWS = DEFAULT_ARROWS;
var MAX_ARROWS = 3;
exports.MAX_ARROWS = MAX_ARROWS;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uL3NyYy9zdHlsZS5qcyJdLCJuYW1lcyI6WyJBcnJvd1N0eWxlcyIsIk5PTkUiLCJGT1JXQVJEIiwiQkFDS1dBUkQiLCJCT1RIIiwiREVGQVVMVF9BUlJPV1MiLCJNQVhfQVJST1dTIl0sIm1hcHBpbmdzIjoiOzs7Ozs7QUFDQTtBQUNPLElBQU1BLFdBQVcsR0FBRztBQUN6QkMsRUFBQUEsSUFBSSxFQUFFLENBRG1CO0FBRXpCQyxFQUFBQSxPQUFPLEVBQUUsQ0FGZ0I7QUFHekJDLEVBQUFBLFFBQVEsRUFBRSxDQUhlO0FBSXpCQyxFQUFBQSxJQUFJLEVBQUU7QUFKbUIsQ0FBcEI7O0FBT0EsSUFBTUMsY0FBYyxHQUFHLENBQXZCOztBQUNBLElBQU1DLFVBQVUsR0FBRyxDQUFuQiIsInNvdXJjZXNDb250ZW50IjpbIi8vIEBmbG93XG4vLyBEZXNjcmliZXMgdGhlIGFycm93IHN0eWxlIG9mIHBvbHlsaW5lc1xuZXhwb3J0IGNvbnN0IEFycm93U3R5bGVzID0ge1xuICBOT05FOiAwLFxuICBGT1JXQVJEOiAxLFxuICBCQUNLV0FSRDogMixcbiAgQk9USDogM1xufTtcblxuZXhwb3J0IGNvbnN0IERFRkFVTFRfQVJST1dTID0gMTtcbmV4cG9ydCBjb25zdCBNQVhfQVJST1dTID0gMztcbiJdfQ==